import React from "react";
import Chart from "react-apexcharts";
import { COLORES_ESTABLECIMIENTO } from "./constants";
import { formatCurrency, truncarNombre } from "./utils";

export default function GraficoEvolucionVentas(props) {
    const moneda = props.moneda || "PEN";

    const options = {
        chart: {
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: COLORES_ESTABLECIMIENTO,
        stroke: { width: 2, curve: "smooth" },
        dataLabels: { enabled: false },
        xaxis: {
            categories: props.timeLine || [],
        },
        yaxis: {
            labels: {
                formatter: (val) => `${Math.round(val / 1000)}K`,
            },
        },
        tooltip: {
            y: {
                formatter: (val) => formatCurrency(val, moneda),
                // El tooltip compartido antepone el nombre de cada serie a
                // su valor; se trunca igual que en la leyenda.
                title: {
                    formatter: (nombreSerie) => truncarNombre(nombreSerie),
                },
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
            formatter: (nombre) => truncarNombre(nombre),
        },
    };

    return (
        <Chart options={options} series={props.series || []} type="line" height={320} />
    );
}
